/*
  LoginRequest.js - LoginRequest Index File

  Contains networking functionality for Login Components
*/

// MODULES
import RequestRabbit from './RequestRabbit';

// CONFIGURATION
import config from '../Config';

// UTILS
import { getMetadata, getPlatformToken } from '../utils/userDevice';

const useLoginRequest = () => {
  // Function to handle user login
  const login = async (email, password, errorHandler) => {
    const browser = getMetadata();
    try {
      const url = `${config.baseServerURL}/auth/login`;
      const body = JSON.stringify({
        email,
        password,
        browser,
      });
      const headers = new Headers({
        'Content-Type': 'application/json',
      });
      const options = {
        method: 'POST',
        body,
        headers,
      };

      // Request
      return await RequestRabbit.request(url, options, errorHandler);
    } catch (e) {
      errorHandler(e.message);
      return null;
    }
  };

  // Function to handle user logout
  const logout = async (email, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/auth/signout`;
      const body = JSON.stringify({ email });
      const headers = new Headers({
        'Content-Type': 'application/json',
      });
      const options = {
        method: 'POST',
        body,
        headers,
      };

      return await RequestRabbit.request(url, options, errorHandler);
    } catch (e) {
      errorHandler(e.message);
      return null;
    }
  };

  const verifyMfa = async (
    code,
    session,
    challenge,
    email,
    rememberMe,
    errorHandler
  ) => {
    return await RequestRabbit.post(
      '/auth/verify-mfa',
      {
        code,
        session,
        challenge,
        email,
        rememberMe,
      },
      errorHandler,
      true
    );
  };

  const resendMfa = async (challenge, email, errorHandler) => {
    return await RequestRabbit.post(
      '/auth/resend-mfa',
      {
        challenge,
        email,
      },
      errorHandler
    );
  };

  // Export functions as a module
  return {
    login,
    logout,
    verifyMfa,
    resendMfa,
  };
};

export default useLoginRequest;
